import { render, staticRenderFns } from "./SelectHowToPayForProjectCard.vue?vue&type=template&id=46bcb2d0&"
import script from "./SelectHowToPayForProjectCard.vue?vue&type=script&lang=ts&"
export * from "./SelectHowToPayForProjectCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports